export default {
  computed: {
    salesRoutes() {
      return {
        sales: {
          name: "sales",
          title: "Vendas"
        },
        "sales-events": {
          name: "sales-events",
          title: "Eventos"
        },
        "sales-subscriptions": {
          name: "sales-subscriptions",
          title: "Assinaturas"
        },
        "sales-courses": {
          name: "sales-courses",
          title: "Cursos"
        },
        "subscriptions-manager": {
          name: "subscriptions-manager",
          title: "Gestão de Assinaturas"
        },
        "sales-recovery": {
          name: "sales-recovery",
          title: "Recuperação de vendas"
        }
      };
    }
  }
};
